import { Card, CardHeader, CardHeading } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";

export const AccessDeniedList: FC = () => {
	const { t } = useTranslation();

	return (
		<Card>
			<CardHeader>
				<CardHeading>
					{t("The content not available for users without a tenant. Please contact the administrators to get access.")}
				</CardHeading>
			</CardHeader>
		</Card>
	);
};
